import React, { useLayoutEffect, useEffect  } from "react";
import Slider from "react-slick";
import { Container, Grid, Box, Button } from '@material-ui/core';
import protocolBanner01 from '../../assets/images/Band-Protocol-Graphic.png';
import protocolBanner02 from '../../assets/images/Pancake-Swap-Graphic.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './videos.css';
import AOS from 'aos';

// const responsive = {
// 	superLargeDesktop: {
// 	  // the naming can be any, depends on you.
// 	  breakpoint: { max: 4000, min: 3000 },
// 	  items: 2
// 	},
// 	desktop: {
// 	  breakpoint: { max: 3000, min: 1024 },
// 	  items: 2
// 	},
// 	tablet: {
// 	  breakpoint: { max: 1024, min: 600 },
// 	  items: 2
// 	},
// 	mobile: {
// 	  breakpoint: { max: 600, min: 0 },
// 	  items: 1
// 	}
//   };
function Videos() {
	var settings = {
		dots: false,
		infinite: true,
		draggable: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }, { breakpoint: 1024, settings: { slidesToShow: 2 } }, { breakpoint: 100000, settings: { slidesToShow: 2 } }]
	};
	useEffect(() => {
		AOS.init({
			disable: 'mobile'
		  });
	});
	return (
		<section className="section-spacing" id="videos">
			<Container maxWidth="lg" className="main-container text-white">
				<Grid container spacing={7}>
					<Grid item xs={12}>
						<Box textAlign="center" className="section-heading text-uppercase">
							<h2 data-aos="fade-up" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" className="text-blue">Educational Videos</h2>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Slider {...settings}>
							<Box data-aos="fade-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200"  className="video-wrapper">
								<h3 className="text-blue">What is Referral Fee? (English)</h3>
								<Box className="videos-box">
									<iframe width="100%" height="315" src="https://www.youtube.com/embed/8bcVk55_9FQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
								</Box>
							</Box>
							<Box data-aos="fade-left" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" className="video-wrapper">
								<h3 className="text-blue">What is ANTG index?</h3>
								<Box className="videos-box">
									<iframe width="560" height="315" src="https://www.youtube.com/embed/2Io2ml2EDXY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
								</Box>
							</Box>
							<Box data-aos="fade-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" className="video-wrapper">
								<h3 className="text-blue">What is ANTG index?</h3>
								<Box className="videos-box">
									<iframe width="560" height="315" src="https://www.youtube.com/embed/2Io2ml2EDXY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
								</Box>
							</Box>
						</Slider>
					</Grid>
					{/* <Carousel > */}

					{/* </Carousel> */}
					<Grid item xs={12}>
						<Box textAlign="center" className="footer-btns-holder">
							<Button data-aos="fade-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" variant="contained" color="primary">Launch the App</Button>
							<Button data-aos="fade-left" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" variant="contained" color="secondary" className="bg-white">xWin Docs</Button>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
}
export default Videos;